module.exports = __webpack_public_path__ + "static/menu_mobile-a9e483093bbedc729e575c9741c0a7ba.svg";